/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nejsou k dispozici žádné kódy slev`
};

const da_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen rabatkoder tilgængelige`
};

const de_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Rabattcodes verfügbar`
};

const en_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `No discount codes available`
};

const es_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `No hay códigos promocionales disponibles`
};

const fr_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun code promo disponible`
};

const hu_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nincsenek promóciós kódok elérhetők`
};

const it_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun codice sconto disponibile`
};

const nl_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Geen kortingscodes beschikbaar`
};

const pl_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Brak dostępnych kodów rabatowych`
};

const pt_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum código promocional disponível`
};

const sv_discount_codes_no_codes_title = /** @type {(inputs: {}) => string} */ () => {
	return `Inga rabattkoder tillgängliga`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_no_codes_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_no_codes_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_no_codes_title", locale)
	if (locale === "cs") return cs_discount_codes_no_codes_title(inputs)
	if (locale === "da") return da_discount_codes_no_codes_title(inputs)
	if (locale === "de") return de_discount_codes_no_codes_title(inputs)
	if (locale === "en") return en_discount_codes_no_codes_title(inputs)
	if (locale === "es") return es_discount_codes_no_codes_title(inputs)
	if (locale === "fr") return fr_discount_codes_no_codes_title(inputs)
	if (locale === "hu") return hu_discount_codes_no_codes_title(inputs)
	if (locale === "it") return it_discount_codes_no_codes_title(inputs)
	if (locale === "nl") return nl_discount_codes_no_codes_title(inputs)
	if (locale === "pl") return pl_discount_codes_no_codes_title(inputs)
	if (locale === "pt") return pt_discount_codes_no_codes_title(inputs)
	return sv_discount_codes_no_codes_title(inputs)
};
export { discount_codes_no_codes_title as "discount_codes.no_codes_title" }